export const COURSE_EMAIL_REMIND_DISABLED_LOCAL_STORAGE = 'course_email_remind_disabled';
